import API from "./restApi";
import { AxiosResponse } from "axios";

let config = require("../configuration/config");

export function apiGetLifeStyle(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/lifestyle`);
}

export function apiAddOrUpdateLifeStyle(formData): Promise<AxiosResponse> {
  return API.post(
    `${config.serverUrl}/api/addorupdateLifeStyle`,
    JSON.stringify(formData),
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json,charset=UTF-8",
      },
    }
  );
}

export function apiDeleteLifeStyle(id): Promise<AxiosResponse> {
  return API.delete(`${config.serverUrl}/api/lifestyle/${id}`);
}
